import React, { createContext, useContext, useState, useEffect } from 'react';

// Logo 7 (Minimalist) is the chosen permanent brand logo
export const LOGO_PRESETS = [
  {
    id: 'logo-7',
    name: 'Logo 7 (Minimalist)',
    label: 'Logo 7',
    url: 'https://assets.auxodev.dk/assets/40e16184-d312-45e0-99c1-a83e20a53a01/brown-minimalist-typographic-candle-business-logo4.jpg',
    bg: '#DFD9CD',
    description: 'Zentai Minimalist Logo'
  }
];

const LogoThemeContext = createContext(null);

export function LogoThemeProvider({ children }) {
  const [selectedLogoId, setSelectedLogoId] = useState('logo-7');

  const currentPreset = LOGO_PRESETS.find(p => p.id === selectedLogoId) || LOGO_PRESETS[0];
  const headerBgColor = currentPreset.bg;

  const selectLogo = (id) => {
    setSelectedLogoId(id);
  };

  // Sync with CSS variables so header and hero always match the logo background seamlessly
  useEffect(() => {
    document.documentElement.style.setProperty('--theme-header-bg', headerBgColor);
    document.documentElement.style.setProperty('--theme-hero-bg', headerBgColor);
  }, [headerBgColor]);

  return (
    <LogoThemeContext.Provider value={{
      presets: LOGO_PRESETS,
      currentPreset,
      selectedLogoId,
      selectLogo,
      headerBgColor
    }}>
      {children}
    </LogoThemeContext.Provider>
  );
}

export function useLogoTheme() {
  const context = useContext(LogoThemeContext);
  if (!context) {
    throw new Error('useLogoTheme must be used within a LogoThemeProvider');
  }
  return context;
}
